import localforage from 'localforage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const BACKGROUND_SYNC_STATUS = {
    Idle: 'idle',
    Syncing: 'syncing',
    Success: 'success',
    Failed: 'failed',
} as const;

export type BackgroundSyncStatus =
    (typeof BACKGROUND_SYNC_STATUS)[keyof typeof BACKGROUND_SYNC_STATUS];

interface BackgroundItemSyncStore {
    itemsNextPage: number | null;
    syncStatus: BackgroundSyncStatus;
    setItemsNextPage: (page: number | null) => void;
    clearItemsNextPage: () => void;
    setSyncStatus: (status: BackgroundSyncStatus) => void;
    reset: () => void;
}

type PersistedState = Pick<BackgroundItemSyncStore, 'itemsNextPage'>;

export const useBackgroundItemSyncStore = create(
    persist<BackgroundItemSyncStore, [], [], PersistedState>(
        (set) => ({
            itemsNextPage: null,
            syncStatus: BACKGROUND_SYNC_STATUS.Idle,
            setItemsNextPage: (page) => set({ itemsNextPage: page }),
            clearItemsNextPage: () => set({ itemsNextPage: null }),
            setSyncStatus: (status) => set({ syncStatus: status }),
            reset: () =>
                set({
                    itemsNextPage: null,
                    syncStatus: BACKGROUND_SYNC_STATUS.Idle,
                }),
        }),
        {
            name: 'background-item-sync',
            storage: createJSONStorage(() => localforage),
            partialize: (state) => ({
                itemsNextPage: state.itemsNextPage,
            }),
        },
    ),
);
